import React from "react";
import {
  Button,
  FormControl,
  Grid,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import FilterBox from "./FilterBox";
import { Filter } from "../types";

interface Props {
  item: Filter;
  options?: any;
  selection: any;
  setSelection: any;
  addSelection: any;
  resetSelection?: any;
  close: any;
}

export default function AmountFilter({
  item,
  options,
  selection,
  setSelection,
  addSelection,
  resetSelection,
  close,
  ...props
}: Props) {
  const val1 = selection?.[0]?.split(" ");
  const val2 = selection?.[1]?.split(" ");
  const [value, setValue] = React.useState(val1 ? val1?.[0] : "none");
  const [inputValue, setInputValue] = React.useState(val1 ? val1?.[1] : "");
  const [criteriaValue, setCriteriaValue] = React.useState(
    val2 ? val2?.[0] : "none"
  );
  const [inputCriteriaValue, setInputCriteriaValue] = React.useState(
    val2 ? val2?.[1] : ""
  );

  const [criteriaShow, setCriteria] = React.useState(!!val2);

  React.useEffect(() => {
    const firstConditionValues = [value, inputValue];
    const secondConditionValues = [criteriaValue, inputCriteriaValue];

    const firstCondition = firstConditionValues?.join(" ");
    const secondCondition = secondConditionValues?.join(" ");

    const result = [
      ...(firstCondition !== "none " ? [firstCondition] : []),
      ...(secondCondition !== "none " ? [secondCondition] : []),
    ];
    setSelection(result);
  }, [setSelection, value, inputValue, criteriaValue, inputCriteriaValue]);

  const addCriteria = () => {
    if (criteriaShow) {
      setCriteriaValue("none");
      setInputCriteriaValue("");
      setCriteria((oldCriteria) => !oldCriteria);
    } else {
      setCriteria((oldCriteria) => !oldCriteria);
    }
  };

  const handleChange = (event: SelectChangeEvent<{ value: unknown }>) => {
    setValue(event.target.value as string);
  };

  const handleCriteriaChange = (
    event: SelectChangeEvent<{ value: unknown }>
  ) => {
    setCriteriaValue(event.target.value as string);
  };

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const validatedValue = value.replace(/[^0-9.]/g, "");
    setInputValue(validatedValue);
  };

  const handleCriteriaInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const validatedValue = value.replace(/[^0-9.]/g, "");
    setInputCriteriaValue(validatedValue);
  };

  React.useEffect(() => {
    if (value === "=") {
      setCriteria(false);
      setCriteriaValue("none");
      setInputCriteriaValue("");
    }
  }, [setCriteria, value]);

  return (
    <div {...props}>
      <FilterBox
        item={item}
        resetSelection={resetSelection}
        addSelection={addSelection}
        selection={selection}
        close={close}
        disableApply={
          selection.length < 1 ||
          value === "none" ||
          (value !== "none" && inputValue === "") ||
          (criteriaValue === "none" && inputCriteriaValue !== "") ||
          (criteriaValue !== "none" && inputCriteriaValue === "")
        }
      >
        <div>
          <FormControl size="small" sx={getStyles.formSelect}>
            <Select
              variant="standard"
              native
              value={value}
              onChange={handleChange}
              inputProps={{
                name: "value",
                id: "value",
              }}
            >
              <option value="none" hidden />
              <option value="equal">=</option>
              <option value="greater_than">&gt;</option>
              <option value="less_than">&lt;</option>
            </Select>
          </FormControl>
          <TextField
            size="small"
            name="inputValue"
            value={inputValue}
            onChange={handleInput}
            sx={getStyles.formInput}
            placeholder="Enter call cost"
          />
        </div>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            size="small"
            disabled={value === "=" || value === "none"}
            onClick={() => addCriteria()}
            sx={getStyles.criteriaButton}
          >
            {!criteriaShow ? "add another criteria" : "remove criteria"}
          </Button>
        </Grid>

        {criteriaShow && (
          <div>
            <FormControl size="small" sx={getStyles.formSelect}>
              <Select
                variant="standard"
                native
                value={criteriaValue}
                onChange={handleCriteriaChange}
                inputProps={{
                  name: "criteriaValue",
                  id: "criteriaValue",
                }}
              >
                {value === "greater_than" ? (
                  <>
                    <option value="none" hidden />
                    <option value="less_than">&lt;</option>
                  </>
                ) : (
                  <>
                    <option value="none" hidden />
                    <option value="greater_than">&gt;</option>
                  </>
                )}
              </Select>
            </FormControl>
            <TextField
              size="small"
              name="inputCriteriaValue"
              value={inputCriteriaValue}
              onChange={handleCriteriaInput}
              placeholder="Enter call cost"
              sx={getStyles.formInput}
            />
          </div>
        )}
      </FilterBox>
    </div>
  );
}
const getStyles = {
  formSelect: {
    marginLeft: 2,
  },
  formInput: {
    marginInline: 2,
  },
  criteriaButton: {
    margin: 1,
  },
};
